import { render, staticRenderFns } from "./WalletTxHistory.vue?vue&type=template&id=161237d4&scoped=true"
import script from "./WalletTxHistory.vue?vue&type=script&lang=js"
export * from "./WalletTxHistory.vue?vue&type=script&lang=js"
import style0 from "./WalletTxHistory.vue?vue&type=style&index=0&id=161237d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161237d4",
  null
  
)

export default component.exports